import styled from 'styled-components';

// import {
//   Button as CommonButton,
//   lightenDarkenColor,
// } from './../../components/common/button';

export const Container = styled.div`
  display: grid;
  height: 100vh;
  width: 100vw;
  align-content: center;
  justify-content: center;
  /* background-color: rgba(0, 0, 0, 0.05); */
  * {
    color: #3d3d3d;
  }
`;

export const HeadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 1.6em;
  font-weight: bold;
  margin-bottom: 1em;
`;

export const Title = styled.h1``;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  & img,
  img:hover {
    height: auto;
    max-width: 200px;
    border: 0px;
  }
`;

export const LoginForm = styled.form`
  width: 95%;
  min-height: 150px;
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 1.2em;
  border: 1px solid gray;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
  width: 75vw;
  padding: 20px;
  min-height: 150px;
  @media (min-width: 600px) {
    width: 50vw;
    /* & input {
      width: 40vw;
    } */
  }
  @media (min-width: 861px) {
    width: 35vw;
    /* & input {
      width: 25vw;
    } */
  }
  @media (min-width: 1201px) {
    width: 25vw;
    /* & input {
      width: 15vw;
    } */
  }
`;
export const BlockFormField = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  /* border: 1px solid red; */
  margin-top: 5px;
  & label {
    font-weight: bold;
    font-size: 1em;
    min-width: 100%;
  }
  & input {
    min-width: 97%;
    margin-bottom: 10px;
    font-size: 1.2em;
    padding: 5px;
    border: 1px solid gray;
    border-radius: 3px;
    &::placeholder {
      color: rgba(0, 0, 0, 0.3);
    }
    &:focus:-webkit-placeholder {
      color: transparent;
    }
    &:focus {
      outline: none;
    }
  }
  & select {
    width: 100%;
    min-width: 100%;
    margin-bottom: 10px;
    padding: 5px;
    border-radius: 3px;
    color: rgba(0, 0, 0, 0.8);
    background-color: rgb(232, 240, 254) !important;
  }
  & button {
    width: 95%;
    min-width: 100%;
  }
`;

export const Helptext = styled.div`
  flex-direction: row;
  font-size: 1em;
  font-weight: bold;
  border-radius:.5em;
  padding-bottom: 30px;
  margin-left: auto;
  text-align:right;
  &:hover {    
    color: #f00000;
  }   
`;
export const ForgotLogin = styled.div`
  flex-direction: row;
  padding-top: 5px;  
  font-size: 1em;
  font-weight: bold;
  text-align:center;
  &:hover {    
    color: #f00000;
  }
`;

export const LoginLabel = styled.label`
  font-size: 1em;
  font-weight: bold;
`;

// export const LoginButton = styled(CommonButton)`
//   height: 30px;
//   width: 100%;
//   margin-top: 20px;
//   padding: 10px 20px;
//   height: 40px;
//   font-weight: normal;
//   background-color: #a62b2b;
//   border-color: #a62b2b;
//   color: #ffffff;
//   &:hover {
//     background-color: ${lightenDarkenColor('#a62b2b', 20)};
//     color: #ffffff;
//   }
//   & i {
//     color: #ffffff;
//     padding-right: 5px;
//     font-size: 1em;
//   }
// `;

export const Text = styled.div`
  font-size: 1em;
`;

export const Error = styled.p`
  color: red;
  text-align: center;
`;

